import colors from "../colors";

export default {
    ...colors,
    primary: colors["truecare-primary"],
    secondary: colors["truecare-secondary"],
    accent: colors["truecare-secondary"],
};
